import { createSlice } from '@reduxjs/toolkit';
import { getTimeoutForUser } from '../utils/sessionConfig';

const initialState = {
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));

      // Use role-based timeout — admin gets 8h, manager 4h, staff 10m
      const timeout = getTimeoutForUser(action.payload);
      const expirationTime = new Date().getTime() + timeout;
      localStorage.setItem('expirationTime', expirationTime);
    },
    logout: (state, action) => {
      state.userInfo = null;
      localStorage.clear();
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;